var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.2c0-.11.09-.2.2-.2h5.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H8.2a.2.2 0 0 1-.2-.2zM10.02 6.219c0-.125.063-.219.188-.219h1.596c.125 0 .188.094.188.219l-.484 5.619c0 .094-.094.156-.188.156h-.656c-.094 0-.187-.062-.187-.156zM11 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.289 1.75 7.5 13c.594 1-.156 2.25-1.281 2.25h-15c-1.156 0-1.875-1.25-1.313-2.25l7.5-13c.563-1 2.031-1 2.594 0M3.508 16h15a.482.482 0 0 0 .406-.75l-7.5-13a.497.497 0 0 0-.844 0l-7.5 13c-.187.344.032.75.438.75",
    clipRule: "evenodd"
  })));
};
export default SvgWarningIcon;